<template>
  <div class="relative">
    <div class="p-10 w-full">
      <div class="mb-2">
        <span class="text-zt-lg font-normal modal-title">{{ $t('message.settingsComponent.list.changeEmail.dialogTitle') }}</span>
      </div>
      <div class="mt-2" v-if="userEmail">
        <div class="my-4 md:my-3">
          <span class="text-zt-md text-zt-dark-300">
            {{ $t('message.settingsComponent.list.changeEmail.currentEmail') }}
          </span>
        </div>
        <div>
          <zt-icon name="envelop" class="text-zt-primary-200 text-zt-lg pb-1" />
          <span class="ml-2 text-lg text-zt-dark-300 font-bold">{{ userEmail }}</span>
        </div>
      </div>
      <div class="text-zt-danger my-4 md:my-3" v-if="messageError">
        {{ messageError }}
      </div>
      <div>
        <div class="my-4 md:my-3">
          <span class="text-zt-md text-zt-dark-300">
            {{ $t('message.settingsComponent.list.changeEmail.labelEmailAndPassword') }}
          </span>
        </div>
        <div class="my-8">
          <zt-input outlined :label="$t('message.settingsComponent.list.changeEmail.labelEmail2')" v-model="userNewMail" />
        </div>
        <div class="my-8">
          <zt-input outlined :label="$t('message.settingsComponent.list.changeEmail.labelPassword2')" type="password" v-model="userPassword" />
        </div>
      </div>
    </div>
    <div class="zt-modal-footer flex justify-center lg:justify-end items-center p-4 fixed md:relative bottom-0 right-0 left-0 pb-4">
      <div class="w-1/2 md:w-1/3">
        <zt-button
          class="ml-1 button-cancel-only-text w-11/12"
          text
          @click="$emit('close')"
          >{{ $t('message.settingsComponent.list.buttonCancel') }}</zt-button
        >
      </div>
      <div class="w-1/2 md:w-1/3">
        <zt-button
          class="ml-1 w-11/12"
          :loader="loading"
          @click="sendEditMail"
          :disabled="!userNewMail || !userPassword"
          >{{ $t('message.settingsComponent.list.save') }}</zt-button
        >
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="isSuccessMessage"
        class="change-mail-success absolute top-0 left-0 w-full h-full bg-white rounded flex justify-center items-center flex-col"
      >
        <div class="w-24">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g id="ec3461d3-169a-40a2-a582-a73c13fc7593" data-name="Layer 2">
              <g id="af0c3ab4-f54f-4a90-9831-bd1238a81b14" data-name="Layer 1">
                <g>
                  <circle
                    id="circle"
                    cx="12"
                    cy="12"
                    r="11"
                    style="fill: none;stroke: #54CAA6;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2px;stroke-dasharray: 1.0161314010620117,3.0483944416046143"
                  />
                </g>
                <polyline
                  id="check"
                  points="5.5 11.24 9.1 15.76 18.5 8.24"
                  style="fill: none;stroke: #54CAA6;stroke-miterlimit: 10;stroke-width: 2px"
                />
              </g>
            </g>
          </svg>
        </div>
        <span class="mt-6 text-zt-success">{{ messageSuccess }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ZtEditMail',
  props: {
    userEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userPassword: '',
      userNewMail: '',
      loading: false,
      messageError: '',
      messageSuccess: '',
      isSuccessMessage: false
    }
  },
  methods: {
    ...mapActions({ setChangeUserMail: 'setChangeUserMail' }),
    sendEditMail() {
      let userData = {
        pass: this.userPassword,
        email: this.userNewMail
      }
      this.loading = true
      this.setChangeUserMail(userData)
        .then(response => {
          this.loading = false
          this.statusResponse(this.$t('message.settingsComponent.list.saveSuccess'), response.status)
        })
        .catch(e => {
          this.loading = false
          this.statusResponse(e.results.data[0], e.status)
        })
    },
    statusResponse(message, status) {
      if (status === 'success') {
        this.isSuccessMessage = true
        this.messageSuccess = message
        this.$emit('success')
      } else {
        this.messageError = message
      }
      setTimeout(() => {
        this.messageError = ''
        this.messageSuccess = ''
      }, 3000)
    }
  }
}
</script>

<style scoped lang="scss">
.change-mail-success {
  i {
    font-size: 70px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#circle {
  color: #fff;
  stroke-dashoffset: 80px;
  stroke-dasharray: 10px;
  animation-name: svgcircle;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
}
@keyframes svgcircle {
  to {
    stroke-dashoffset: 11.5%;
  }
}
.modal-title {
  color: #575757;
}
@media screen and (min-width: 1024px) {
  .zt-modal-footer {
    background-color: #eeeeee;
    .button-cancel-only-text {
      background-color: #eeeeee !important;
      color: #949494 !important;
    }
  }
}
.zt-modal-footer {
  .zt-button {
    font-weight: 500;
    box-shadow: none;
  }
  .button-cancel-only-text {
    color: #949494 !important;
  }
}
</style>
